import React, { useEffect, useState } from "react";
//Components
import TablaOrd from "./TablaOrd";
import NuevaOrdProd from "./NuevaOrdProd";
import EditarOrd from "./EditarOrd";
import BorrarOrd from "./BorrarOrd";
import Importar from "./Importar";
//Material-UI
import { Button } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
//Icons
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
//Context
import { OrdProdProvider, useOrdProd } from './OrdProdContext';
import '../../styles/lista-ordenes.css';
import '../../popup.css';

function escapeRegExp(value) {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function OrdenProduct() {
  const { fechaIni, setFechaIni, openSnack, setOpenSnack,
    fechaFin, setFechaFin, snackMsg,
    selectionModel, getOrders, transformDate, orden } = useOrdProd();
  const [searchText, setSearchText] = useState('');
  const [rows, setRows] = useState([]);

  useEffect(() => { setRows(orden); }, [orden]);

  const requestSearch = (value) => {
    setSearchText(value);
    if (!value) { setRows(orden); return; }
    const re = new RegExp(escapeRegExp(value), 'i');
    setRows(orden.filter(row =>
      Object.keys(row).some(f => re.test(row[f]?.toString() ?? ''))
    ));
  };

  const handleIniChange = (date) => {
    setFechaIni(date);
  };

  const handleFinChange = (date) => {
    setFechaFin(date);
  };

  const buscarOrdenes = (event) => {
    event.preventDefault();
    getOrders(`${transformDate(fechaIni)}T00:00:00`, `${transformDate(fechaFin)}T23:59:59`);
  };

  const handleClose = () => {
    setOpenSnack(false);
  };

  useEffect(() => {
    const base = fechaIni;
    base.setDate(base.getDate() - 30);
    setFechaIni(base);
  }, [fechaIni, setFechaIni]);

  return (
    <div className="ordenes-page">

      <div className="ordenes-header">
        <div className="ordenes-header-left">
          <h1 className="titulo">Lista de órdenes</h1>
          <p className="ordenes-desc">
            En esta lista de órdenes puedes hacer click en una órden para
            seleccionarla y así editarla o borrarla
          </p>
        </div>
      </div>

      <div className="ordenes-filters">
        <div className="ordenes-filters-dates">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              variant="inline"
              format="dd/MM/yyyy"
              margin="normal"
              name="uxFechaIni"
              label="FECHA INICIAL"
              autoOk
              value={fechaIni}
              onChange={handleIniChange}
              KeyboardButtonProps={{ 'aria-label': 'change date' }}
            />
          </MuiPickersUtilsProvider>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              variant="inline"
              format="dd/MM/yyyy"
              margin="normal"
              name="uxFechaFin"
              label="FECHA FINAL"
              autoOk
              value={fechaFin}
              onChange={handleFinChange}
              KeyboardButtonProps={{ 'aria-label': 'change date' }}
            />
          </MuiPickersUtilsProvider>
        </div>
        <Button
          variant="contained"
          color="primary"
          onClick={(event) => buscarOrdenes(event)}
          className="listado-ordenes-button"
        >
          Buscar
        </Button>
      </div>

      <div className="ordenes-card">
        <div className="ordenes-card-toolbar">
          <span className="ordenes-selected-count">
            {selectionModel.length} seleccionados
          </span>

          <TextField
            variant="outlined"
            size="small"
            value={searchText}
            onChange={e => requestSearch(e.target.value)}
            placeholder="Buscar..."
            className="table-search-inline"
            InputProps={{
              startAdornment: <SearchIcon fontSize="small" />,
              endAdornment: (
                <IconButton
                  size="small"
                  className={searchText ? 'table-search-clear-visible' : 'table-search-clear-hidden'}
                  onClick={() => requestSearch('')}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              ),
            }}
          />

          <div className="ordenes-card-actions">
            <Importar />
            <NuevaOrdProd />
            <EditarOrd />
            <BorrarOrd />
          </div>
        </div>
        <div className="ordenes-table-wrapper">
          <TablaOrd rows={rows} />
        </div>
      </div>

      <Snackbar open={openSnack} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          {snackMsg}
        </Alert>
      </Snackbar>

    </div>
  );
}

let listaOrdenesComponent = () => (
  <OrdProdProvider>
    <OrdenProduct />
  </OrdProdProvider>
);

export default listaOrdenesComponent;
